/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function KanshiAlert(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: { text: {}, KanshiAlert: {} },
      variantValues: { type: "default", situation: "Kansyoha" },
    },
    {
      overrides: {
        text: {},
        KanshiAlert: { backgroundColor: "rgba(255,76,79,1)" },
      },
      variantValues: { type: "error", situation: "Kansyoha" },
    },
    {
      overrides: {
        text: { children: "\u6A5F\u5668\u76E3\u8996" },
        KanshiAlert: {},
      },
      variantValues: { type: "default", situation: "Kiki" },
    },
    {
      overrides: {
        text: {},
        KanshiAlert: { backgroundColor: "rgba(250,180,50,1)" },
      },
      variantValues: { type: "warning", situation: "Kansyoha" },
    },
    {
      overrides: {
        text: { children: "\u6A5F\u5668\u76E3\u8996" },
        KanshiAlert: { backgroundColor: "rgba(255,76,79,1)" },
      },
      variantValues: { type: "error", situation: "Kiki" },
    },
    {
      overrides: {
        text: { children: "\u6A5F\u5668\u76E3\u8996" },
        KanshiAlert: { backgroundColor: "rgba(250,180,50,1)" },
      },
      variantValues: { type: "warning", situation: "Kiki" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="10px"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      borderRadius="4px"
      padding="16px 24px 16px 24px"
      backgroundColor="rgba(38,193,147,1)"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "KanshiAlert")}
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="700"
        color="rgba(255,255,255,1)"
        lineHeight="16px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.65px"
        width="158px"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="干渉波監視"
        {...getOverrideProps(overrides, "text")}
      ></Text>
    </Flex>
  );
}
